export default {
      id: "observation-preview-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "sprite.svg#observation-preview",
      toString: function () {
        return this.url;
      }
    }